import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'events/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('events/', '')
      .toLowerCase();
  }
}
